import { Helmet } from 'react-helmet-async';
import { useGetCRM } from 'src/api/appointments';
import { useGetCanvassers } from 'src/api/canvasser';
import { useGetDashboardReminder } from 'src/api/dashboard';
import { useAuthContext } from 'src/auth/hooks';
import { LoadingScreen } from 'src/components/loading-screen';
import GoBackListView from 'src/sections/go-back/view/go-back-list-view';

export default function GoBackListPage() {

  // const {user} = useAuthContext()

  // const managerId = user?.canvasserManagerId

  // const {leads, leadsloading} = useGetCRM(managerId)
  const { reminders } = useGetDashboardReminder();
  console.log(reminders,"djfhdsjkfhsejfhsj")
let leadsloading=false
  return (
    <>
      <Helmet>
        <title>Go Back Reminders - LMS</title>
      </Helmet>

      {leadsloading ? (
        <LoadingScreen />
      ) : (
        <GoBackListView reminders={reminders} />
      )}
    </>
  );
}
